import { L11N } from "./l11n_content";
import { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from "@/lib/enums";
import { getFirstBrowserLanguage } from "@/lib/web";
import { localStorageGet, localStorageSet } from "@/lib/storage";

export function getL11nString(key) {
  const lang = getEffectiveUiLanguage();
  // if (doLog()) console.log(`getL11nString: ${key} for ${lang}`);
  return L11N[lang][key];
}

export function getEffectiveUiLanguage() {
  const CACHE_KEY = "effective_ui_language";
  const cachedLang = localStorageGet(CACHE_KEY);
  if (cachedLang) {
    return cachedLang;
  }
  const mlParam = new URLSearchParams(window.location.search).get("ml");
  const userLang = getFirstBrowserLanguage();
  const lang = (mlParam ?? userLang.split("-")[0] ?? "en").toUpperCase();
  const effectiveLang = SUPPORTED_LANGUAGES.includes(lang) ? lang : "EN";
  localStorageSet(CACHE_KEY, effectiveLang);

  // Only set the language attribute, not the direction
  document.documentElement.lang = effectiveLang.toLowerCase();

  return effectiveLang;
}

// Helper function to check if current language is RTL
export function uiLangIsRtl() {
  const lang = getEffectiveUiLanguage();
  const out = RTL_LANGUAGES.includes(lang);
  // console.log("uiLangIsRtl", lang, out);
  return out;
}

export function uiDirectionality() {
  return uiLangIsRtl() ? "rtl" : "ltr";
}
